module.exports = __webpack_public_path__ + "static/media/iconCanvas09.e579c66c.svg";